import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { StatusItem } from "@ServerTypes/status/status.schema";

type IssueStatusMap = Record<string, StatusItem>;

const initialIssuesStatusesState: IssueStatusMap = {};

const issuesStatusesSlice = createSlice({
  name: "issuesStatuses",
  initialState: initialIssuesStatusesState,
  reducers: {
    setIssuesStatusesData: (_state: IssueStatusMap, action: PayloadAction<StatusItem[]>) =>
      action.payload.reduce(
        (prev: IssueStatusMap, curr: StatusItem) => ({ ...prev, [curr.id ?? curr._id ?? ""]: curr }),
        {},
      ),
  },
});

export const { setIssuesStatusesData } = issuesStatusesSlice.actions;

export const issuesStatuses = issuesStatusesSlice.reducer;

export default issuesStatusesSlice.reducer;
